import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/bootstrap/form-field';

@Component({
    selector: 'app-null',
    templateUrl: './null.component.html',
    styleUrls: ['./null.component.scss'],
    standalone: false
})
export class NullComponent extends FieldType {


}
